import { HttpClient } from '@angular/common/http';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

type AssetBlobMode = 'json' | 'text' | 'image';

// type StorageAsset = AssetVisjs | AssetBase64 | AssetSvgSource | AssetSvgDefs | AssetFamilyTree ;
type StorageAsset = { storagePath: string };

@Pipe({
	name: 'assetStorage',
	pure: true,
	standalone: true,
})
export class AssetStoragePipe implements PipeTransform {
	private readonly http = inject(HttpClient);
	private readonly sanitizer = inject(DomSanitizer);

	transform(
		assetOrStoragePath: StorageAsset | string | null | undefined,
		mode: AssetBlobMode = 'json'
	): Observable<unknown> | undefined {
		const storagePath =
			typeof assetOrStoragePath === 'string'
				? assetOrStoragePath
				: assetOrStoragePath?.storagePath;
		if (!storagePath) return undefined;

		const url = `${environment.apiBaseUrl}${environment.endpoint.assets.base}/storage`;
		switch (mode) {
			case 'json':
				return this.http.get(url, {
					params: { path: storagePath },
					responseType: 'json',
				});
			case 'text':
				return this.http.get(url, {
					params: { path: storagePath },
					responseType: 'text',
				});
			case 'image':
				return this.http
					.get(url, {
						params: { path: storagePath },
						responseType: 'blob',
					})
					.pipe(
						map((blob) =>
							this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))
						)
					);
			default:
				return this.http.get(url, {
					params: { path: storagePath },
					responseType: 'text',
				});
		}
	}
}
